import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const login = r => require.ensure([], () => r(require('./page/login.vue')), 'login')//登录
const user = r => require.ensure([], () => r(require('./page/user.vue')), 'user') //用户管理
const dict = r => require.ensure([], () => r(require('./page/dict.vue')), 'dict') //数据字典
const home = r => require.ensure([], () => r(require('./page/home.vue')), 'home') //首页称重

let routeObj = {login,user,dict};

const routes = [];

for (let name in routeObj ) {
    routes.push({path:`/${name}`,name,component:routeObj[name]});
}

routes.push({path:`/`,name:'home',component:home});

const router = new VueRouter({routes});

router.beforeEach((to, from, next) => {
    let toName = to.name;
    let toPath = to.path;
    if (toName == 'login') {//登录界面
        if (localStorage.token) {//已经登录的
            sessionStorage.hasBar = 1;
            let path = '/';
            sessionStorage.toPath = path;
            next({path});
        } else {
            sessionStorage.hasBar = 0;
            next();
        }
    }else{//非登录界面
        if (localStorage.token) {//已登录
            if(!toName){//没有定义的路由
                let role = JSON.parse(localStorage.user).role;
                sessionStorage.hasBar = 1;
                let path = role == 0 ? '/' : '/'
                sessionStorage.toPath = path;
                return next({path});
            }
            if(['printCase'].indexOf(toName) > -1){
                sessionStorage.hasBar = 0;
            }else sessionStorage.hasBar = 1;
            sessionStorage.toPath = toPath;
            next();
        }else {
            sessionStorage.hasBar = 0;
            next({path: '/login'});
        }
    }
})

export default router;